<template>
  <div class="d-flex">
    <div>
      <v-navigation-drawer
        permanent
        color="white"
        width="280"
        class="drawer-compact"
      >
        <v-list dense nav>
          <template v-for="item in drawerItems">
            <v-list-group
              v-if="item.children && item.children.length"
              :key="item.value"
              :prepend-icon="item.icon"
              no-action
              class="drawer-group"
            >
              <template v-slot:activator>
                <v-list-item-content>
                  <v-list-item-title class="ml-1">{{
                    item.title
                  }}</v-list-item-title>
                </v-list-item-content>
              </template>
              <v-list-item
                v-for="sub in item.children"
                :key="sub.value"
                :to="sub.route"
                link
                class="drawer-subitem"
                :active-class="'drawer-item--active'"
              >
                <v-list-item-content>
                  <v-list-item-title
                    >{{ sub.title }}
                    <span v-if="sub.http"
                      ><v-chip
                        class="chip text-white"
                        :color="
                          sub.http === 'POST'
                            ? '#2196F3'
                            : sub.http === 'PUT'
                            ? '#FF9800'
                            : '#4CAF50'
                        "
                        >{{ sub.http }}</v-chip
                      ></span
                    ></v-list-item-title
                  >
                </v-list-item-content>
              </v-list-item>
            </v-list-group>
            <v-list-item
              v-else
              :key="item.value"
              :to="item.route"
              link
              class="drawer-item"
              :active-class="'drawer-item--active'"
            >
              <v-list-item-icon>
                <v-icon :color="item.color || 'primary'">{{
                  item.icon
                }}</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>{{ item.title }}</v-list-item-title>
                <v-list-item-subtitle v-if="item.subtitle">{{
                  item.subtitle
                }}</v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </template>
        </v-list>
      </v-navigation-drawer>
    </div>

    <div class="pb-5 d-flex flex-column mx-4 px-2">
      <transition name="slide-x-transition" mode="out-in">
        <router-view />
      </transition>
    </div>
  </div>
</template>
<script>
export default {
  name: "NuevoDesarrolladores",
  data() {
    return {
      drawerItems: [
        {
          title: "Solicitudes de Pagos",
          icon: "mdi-folder-outline",
          value: "docs",
          color: "deep-purple",
          children: [
            {
              title: "Crear Solicitud de pago",
              http: "POST",
              icon: "mdi-book-open-page-variant",
              value: "CSDP",
              route: "/desarrolladores/crear-solicitud-pago",
              color: "deep-purple",
            },
            {
              title: "Integración con webHooks",
              http: "POST",
              icon: "mdi-file-document-edit",
              value: "IW",
              route: "/desarrolladores/integracion-webhooks",
              color: "deep-purple",
            },
            {
              title: "Consultar Estado del Pago",
              http: "POST",
              icon: "",
              value: "CEP",
              route: "/desarrolladores/consultar-pago",
              color: "deep-purple",
            },

            {
              title: "Actualizar Pago",
              http: "PUT",
              icon: "mdi-file-document-edit",
              value: "AP",
              route: "/desarrolladores/actualizar-expiracion-pago",
              color: "deep-purple",
            },
          ],
        },
        {
          title: "Reportes",
          icon: "mdi-folder-outline",
          value: "devs",
          color: "teal",
          children: [
            {
              title: "Cobranzas",
              http: "GET",
              icon: "mdi-account-group",
              value: "cobranzas",
              route: "/desarrolladores/cobranzas",
              color: "teal",
            },
            {
              title: "Reversiones",
              http: "GET",
              icon: "mdi-tools",
              value: "reversiones",
              route: "/desarrolladores/reversiones",
              color: "teal",
            },
            {
              title: "Rendiciones",
              http: "GET",
              icon: "mdi-tools",
              value: "rendiciones",
              route: "/desarrolladores/rendiciones",
              color: "teal",
            },
            {
              title: "Retenciones",
              http: "GET",
              icon: "mdi-tools",
              value: "retenciones",
              route: "/desarrolladores/retenciones",
              color: "teal",
            },
          ],
        },
      ],
    };
  },
};
</script>
<style scoped>
.drawer-compact {
  border-radius: 0;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
  overflow-y: auto;
}
.drawer-item {
  border-radius: 8px;
  margin-bottom: 4px;
  transition: background 0.2s;
}
.drawer-subitem {
  border-radius: 8px;
  margin-bottom: 2px;
  margin-left: 16px;
  transition: background 0.2s;
}
.drawer-item--active {
  background: #e3f2fd !important;
}
.v-list-item__title {
  font-weight: 500;
}
.chip {
  font-size: 9px;
  scale: 0.75;
  margin-left: 4px;
}
.section-title {
  font-size: 1.3rem;
  font-weight: 600;
  color: #1976d2;
  letter-spacing: 0.5px;
}
</style>
